import { metadataProperties } from './metadataProperties';
import { createUISchemaFromMetadataProps } from '../../../utils';

export const uischema = createUISchemaFromMetadataProps(metadataProperties);
